import React from 'react';
import { useBreakpoint } from 'hooks';
import { Switch, Card } from 'components';
import { StyledGrid } from '../StyledComponents';

import { OpenHouseSettingsProps } from '../types';

const OpenHouse: React.FC<OpenHouseSettingsProps> = ({
  handleChangeSettings,
  enableOpenHouses,
  title,
}) => {
  const breakpoints = useBreakpoint();
  return (
    <Card type="primary" title={title} id="openHouses">
      <StyledGrid $breakpoints={breakpoints}>
        <Switch
          label="Enable Open Houses"
          data-cy="enableOpenHouses-switch"
          checked={enableOpenHouses}
          onClick={() => {
            handleChangeSettings('enableOpenHouses');
          }}
        />
      </StyledGrid>
    </Card>
  );
};

export default OpenHouse;
